export default __webpack_public_path__ + "static/wamo-unlimit-your-business-7142882387af200df0d8c0d64ecc0d94.jpg";